var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTimerPause = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 15.1667C4.5065 15.1667 1.6665 12.3267 1.6665 8.83333C1.6665 5.34 4.5065 2.5 7.99984 2.5C11.4932 2.5 14.3332 5.34 14.3332 8.83333C14.3332 9.10667 14.1065 9.33333 13.8332 9.33333C13.5598 9.33333 13.3332 9.10667 13.3332 8.83333C13.3332 5.89333 10.9398 3.5 7.99984 3.5C5.05984 3.5 2.6665 5.89333 2.6665 8.83333C2.6665 11.7733 5.05984 14.1667 7.99984 14.1667C8.27317 14.1667 8.49984 14.3933 8.49984 14.6667C8.49984 14.94 8.27317 15.1667 7.99984 15.1667Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16671C7.72667 9.16671 7.5 8.94004 7.5 8.66671V5.33337C7.5 5.06004 7.72667 4.83337 8 4.83337C8.27333 4.83337 8.5 5.06004 8.5 5.33337V8.66671C8.5 8.94004 8.27333 9.16671 8 9.16671Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.83337H6C5.72667 1.83337 5.5 1.60671 5.5 1.33337C5.5 1.06004 5.72667 0.833374 6 0.833374H10C10.2733 0.833374 10.5 1.06004 10.5 1.33337C10.5 1.60671 10.2733 1.83337 10 1.83337Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 14.5C12.3932 14.5 12.1665 14.2734 12.1665 14V11.3334C12.1665 11.06 12.3932 10.8334 12.6665 10.8334C12.9398 10.8334 13.1665 11.06 13.1665 11.3334V14C13.1665 14.2734 12.9398 14.5 12.6665 14.5Z",
    fill: "#455CC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 14.5C10.3932 14.5 10.1665 14.2734 10.1665 14V11.3334C10.1665 11.06 10.3932 10.8334 10.6665 10.8334C10.9398 10.8334 11.1665 11.06 11.1665 11.3334V14C11.1665 14.2734 10.9398 14.5 10.6665 14.5Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimerPause, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timer-pause.40a0fb90.svg";
export { ForwardRef as ReactComponent };